
(function () {
  const DESKTOP_BREAKPOINT = 1000;
  const STICKY_CLASS = "--is-desktop-sticky";

  function updateStickyColumn(gallery, info) {
    if (window.innerWidth < DESKTOP_BREAKPOINT) {
      gallery.classList.remove(STICKY_CLASS);
      info.classList.remove(STICKY_CLASS);
      return;
    }

    if (gallery.scrollHeight >= info.scrollHeight) {
      info.classList.add(STICKY_CLASS);
      gallery.classList.remove(STICKY_CLASS);
    } else {
      gallery.classList.add(STICKY_CLASS);
      info.classList.remove(STICKY_CLASS);
    }
  }

  function initStickyColumns() {
    const gallery = document.querySelector(".product-gallery");
    const info = document.querySelector(".product-info");
    if (!gallery || !info) return;

    const update = function () { updateStickyColumn(gallery, info); };

    new ResizeObserver(update).observe(gallery);
    new ResizeObserver(update).observe(info);
    window.addEventListener("resize", update, { passive: true });
    new MutationObserver(update).observe(gallery, { childList: true, subtree: true });

    update();
  }

  // ─── Yotpo star empty color ───────────────────────────────────────────────
  const STAR_EMPTY_COLOR = "#C2BDB8";
  const PRIMARY_PATTERN = /rgba?\(\s*29\s*,\s*29\s*,\s*29/i;

  function patchYotpoStars() {
    const gradients = document.querySelectorAll('[id^="yotpo_stars_gradient"]');
    gradients.forEach(function (gradient) {
      gradient.querySelectorAll("stop").forEach(function (stop) {
        const color = stop.getAttribute("stop-color") || stop.style.stopColor || "";
        if (color && !PRIMARY_PATTERN.test(color)) {
          stop.setAttribute("stop-color", STAR_EMPTY_COLOR);
        }
      });
    });
  }

  const YOTPO_WIDGET_GUID = "X22GuYN5pq5mrnx835ox3A";
  // const YOTPO_WIDGET_GUID = "qgcz2LsMkSPdgxmvQ628YVZwcaJ2yDpddHX4MgA0";

  function hookYotpoWidget() {
    const guids = window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.guids;
    if (!guids) return false;

    const widget = guids[YOTPO_WIDGET_GUID];
    if (!widget) return false;

    let _fn = widget.onInitializerLoad;

    Object.defineProperty(widget, 'onInitializerLoad', {
      get() {
        return _fn;
      },
      set(fn) {
        _fn = function () {
          const result = fn.apply(this, arguments);
          patchYotpoStars();
          return result;
        };
      },
      configurable: true
    });

    // Wrap the already-set value by triggering the setter
    if (_fn) widget.onInitializerLoad = _fn;

    return true;
  }

  function initYotpoStarColors() {
    patchYotpoStars();

    if (!hookYotpoWidget()) {
      const interval = setInterval(function () {
        if (hookYotpoWidget()) clearInterval(interval);
      }, 300);
      setTimeout(function () { clearInterval(interval); }, 1000);
    }
  }

  // ─── Init ─────────────────────────────────────────────────────────────────
  function init() {
    initStickyColumns();
    initYotpoStarColors();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
